import React from "react";

import { useHistory } from "react-router-dom";

// Images imports
import Logo from "../../assets/images/common/logo.jpg";

// components imports
import Button from "../../components/common/Button/Button";

// Scss imports
import css from "./Header.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";

import { logout } from "../../redux/actions/loginAction";

interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const loginStatus = useSelector((state: any) => state.login.loggedIn);
  return (
    <div className={css.container}>
      <img src={Logo} alt="Logo" />
      <div>
        <h1 className={!loginStatus ? css.text : ""}>Архивар</h1>
      </div>
      <div>
        {loginStatus && (
          <Button
            text="Излогуј се"
            onButtonClickHandler={() => dispatch(logout(history))}
            type="processorsButton"
          />
        )}
      </div>
    </div>
  );
};

export default Header;
